import { render, staticRenderFns } from "./CustomFieldsSettings.vue?vue&type=template&id=89614ba2&"
import script from "./CustomFieldsSettings.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89614ba2')) {
      api.createRecord('89614ba2', component.options)
    } else {
      api.reload('89614ba2', component.options)
    }
    module.hot.accept("./CustomFieldsSettings.vue?vue&type=template&id=89614ba2&", function () {
      api.rerender('89614ba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/CustomFieldsSettings.vue"
export default component.exports